import React from 'react';

import { fightersList } from '../../../enums/uiConfig';
import { globalTranslationKeys } from '../../../enums';

export const TutorialCashOutButton = ({ tutorialData, t, tutorialStep }) => {
  return (
    <div className='bottom-cash-out-container'>
      <div className='bottom-cash-out-container-inner'>
        {tutorialData.map((item) => (
          // ADD CLASS " disabled "
          <div className='bottom-cash-out-tabs' key={item}>
            {/*  ADD Class "fighter1, fighter2, fighter3, state-try-again "  */}
            <div
              className={`bet-inner-container ${tutorialStep !== 2 ? 'passive' : ''} ${
                tutorialStep === 2 && item !== 1 ? 'state-try-again' : ''
              } ${tutorialStep === 2 && item !== 1 ? '' : fightersList[item].className}`}
              key={item}
            >
              {/* this buttons wil be changed */}
              <div className='cash-out-head-button'>
                {/* ADD CLASS " type-cash-out, state-no-bet, try-again " */}
                <button
                  className={`bet-button ${
                    (tutorialStep === 2 && item === 1) || tutorialStep !== 2 ? 'type-cash-out' : ''
                  } ${tutorialStep === 2 && item !== 1 ? 'try-again' : ''}`}
                >
                  <span className='big-button-cash-out-text passive'>
                    {tutorialStep === 2 && item !== 1
                      ? t(globalTranslationKeys.TryAgain)
                      : t(globalTranslationKeys.CashOut)}
                  </span>
                  <span className='big-btn-cash-out-num-text'>
                    {(tutorialStep === 2 && item === 1) || tutorialStep !== 2 ? '$500.600' : ''}
                  </span>
                </button>
              </div>
              {tutorialStep === 1 || (tutorialStep === 2 && item === 1) ? (
                <div className='cash-out-50-btn-cont'>
                  {/* ADD CLASS " cashed " */}
                  <button className={`cash-out-50-btn`}>
                    <span className='cash-out-50-btn-text'>{t(globalTranslationKeys.CashOut)}</span>
                    <span className='cash-out-text-half'>50%</span>
                  </button>
                </div>
              ) : (
                <></>
              )}
            </div>
            {tutorialStep === 3 ? (
              <div className='cash-out-50-btn-cont'>
                {/* ADD CLASS " cashed " */}
                <button className={`cash-out-50-btn`}>
                  <span className='cash-out-50-btn-text'>{t(globalTranslationKeys.CashOut)}</span>
                  <span className='cash-out-text-half'>50%</span>
                </button>
              </div>
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
